import DataTable, {Order} from "datatables.net-bs5";
import * as Highcharts from "highcharts";
import {on} from './util';
import { getChartTheme } from './utils/chartTheme';

declare const alcohol_dow : any[];
declare const alcohol_monthly : any[];
declare const corr_data : any;
declare const nutrition_names : string[];
declare const nutrition_calories : number[];
declare const nutrition_carbs : number[];

export default class {
    static init = () => {
        alcohol();
        history();
        stats();
        nutrition();
        compare();
        correlations();
    }
}

function alcohol() {
    let table = document.querySelector('.datatable[data-table="alcohol_list"]') as HTMLElement;
    if(!table) {
        return;
    }

    let datatable = new DataTable('.datatable[data-table="alcohol_list"]',{
        pageLength: 20,
        lengthMenu: [10,20,50,100],
        processing: true,
        serverSide: true,
        ajax: {
            url: '?do=getAlcohol',
            data: function(data) {
                return data;
            }
        },
        columns: [
            { data: 'name' },
            { data: 'ml' },
            { data: null, render: function(data) {
                return data.abv + '%';
            }},
            { data: 'pure_ml' },
            { data: null, render: function(data) {
                return data.price ? '$' + data.price.toFixed(2) : '-';
            }},
            { data: null, render: function(data) {
                return data.price_per_pure_ml ? data.price_per_pure_ml.toFixed(2) : '-';
            }},
            { data: null, render: function(data) {
                return data.calories !== null ? data.calories.toFixed(2) : '-';
            }},
            { data: null, render: function(data) {
                return data.carbs !== null ? data.carbs.toFixed(2) : '-';
            }},
        ],
        order: [[0,"asc"]] as Order[],
    });
}

function history() {
    let table = document.querySelector('.datatable[data-table="alcohol_history"]') as HTMLElement;
    if(!table) {
        return;
    }

    let datatable = new DataTable('.datatable[data-table="alcohol_history"]',{
        pageLength: 20,
        lengthMenu: [10,20,50,100],
        processing: true,
        serverSide: true,
        ajax: {
            url: '?do=getHistory',
            data: function(data) {
                return data;
            }
        },
        columns: [
            { data: 'date' },
            { data: 'day_name' },
            { data: 'qty' },
            { data: 'running_total' },
        ],
        order: [[0,"desc"]] as Order[],
    });
}

function stats() {
    if(typeof alcohol_dow === 'undefined') {
        return;
    }

    // Day of week chart
    Highcharts.chart('chart_dow', Highcharts.merge(getChartTheme(), {
        chart: { type: 'column', height: 320 },
        title: { text: 'Drinks by Day of Week', style: { fontSize: '14px' } },
        xAxis: {
            categories: alcohol_dow.map(d => d.name),
        },
        yAxis: {
            title: { text: '' },
            gridLineWidth: 0.1
        },
        legend: { enabled: false },
        series: [{
            type: 'column',
            name: 'Drinks',
            data: alcohol_dow.map(d => d.total),
            color: '#3BABD3'
        }],
        credits: { enabled: false }
    }));

    // Monthly totals chart
    Highcharts.chart('chart_monthly', Highcharts.merge(getChartTheme(), {
        chart: { type: 'column', height: 320 },
        title: { text: 'Monthly Totals', style: { fontSize: '14px' } },
        xAxis: {
            categories: alcohol_monthly.map(d => d.month),
            labels: { rotation: -45 }
        },
        yAxis: {
            title: { text: '' },
            gridLineWidth: 0.1
        },
        legend: { enabled: false },
        series: [{
            type: 'column',
            name: 'Drinks',
            data: alcohol_monthly.map(d => d.total),
            color: '#3BABD3'
        }],
        credits: { enabled: false }
    }));
}

function nutrition() {
    let table = document.querySelector('.datatable[data-table="alcohol_nutrition"]') as HTMLElement;
    if(!table) {
        return;
    }

    let datatable = new DataTable('.datatable[data-table="alcohol_nutrition"]',{
        pageLength: 20,
        lengthMenu: [10,20,50,100],
        processing: true,
        serverSide: true,
        ajax: {
            url: '?do=getNutrition',
            data: function(data) {
                return data;
            }
        },
        columns: [
            { data: 'name' },
            { data: null, render: function(data) {
                return data.calories_per_drink !== null ? data.calories_per_drink.toFixed(2) : '-';
            }},
            { data: null, render: function(data) {
                return data.carbs_per_drink !== null ? data.carbs_per_drink.toFixed(2) : '-';
            }},
        ],
        order: [[1,"desc"]] as Order[],
    });

    // Calorie ranking chart
    if(typeof nutrition_names !== 'undefined' && nutrition_names.length > 0) {
        Highcharts.chart('chart_nutrition', Highcharts.merge(getChartTheme(), {
            chart: { type: 'bar', height: 400 },
            title: { text: 'Top 10 by Calories per Drink', style: { fontSize: '14px' } },
            xAxis: {
                categories: nutrition_names,
            },
            yAxis: {
                title: { text: '' },
                gridLineWidth: 0.1
            },
            series: [
                { type: 'bar', name: 'Calories', data: nutrition_calories, color: '#FF5733' },
                { type: 'bar', name: 'Carbs (g)', data: nutrition_carbs, color: '#FFC300' }
            ],
            credits: { enabled: false }
        }));
    }
}

function compare() {
    let btn = document.querySelector('.js-compare-btn') as HTMLElement;
    if(!btn) {
        return;
    }

    btn.addEventListener('click', () => {
        let select = document.querySelector('.js-alcohol-compare') as HTMLSelectElement;
        let ids = Array.from(select.selectedOptions).map(o => parseInt(o.value));

        if(ids.length < 2) {
            alert('Select at least 2 drinks to compare');
            return;
        }

        let params = new URLSearchParams();
        ids.forEach(id => params.append('ids[]', id.toString()));

        fetch('?do=getAlcoholDetails&' + params.toString())
            .then(res => res.json())
            .then((drinks: any[]) => {
                let results = document.getElementById('compare-results')!;
                let header = document.getElementById('compare-header')!;
                let body = document.getElementById('compare-body')!;

                header.innerHTML = '<th>Metric</th>';
                drinks.forEach(d => {
                    header.innerHTML += `<th>${d.name}</th>`;
                });

                let metrics = [
                    { label: 'mL', key: 'ml', suffix: '', best: 'none', prefix: '' },
                    { label: 'ABV', key: 'abv', suffix: '%', best: 'none', prefix: '' },
                    { label: 'Pure mL', key: 'pure_ml', suffix: '', best: 'max', prefix: '' },
                    { label: 'Price', key: 'price', suffix: '', best: 'min', prefix: '$' },
                    { label: 'Pure mL/$', key: 'pure_ml_per_dollar', suffix: '', best: 'max', prefix: '' },
                    { label: 'Calories/100mL', key: 'calories', suffix: '', best: 'min', prefix: '' },
                    { label: 'Carbs/100mL', key: 'carbs', suffix: '', best: 'min', prefix: '' },
                ];

                body.innerHTML = '';
                metrics.forEach(m => {
                    let values = drinks.map(d => d[m.key]);
                    let numValues = values.filter(v => v !== null) as number[];
                    let best = m.best === 'max' ? Math.max(...numValues) :
                               m.best === 'min' ? Math.min(...numValues) : null;

                    let row = `<tr><td><strong>${m.label}</strong></td>`;
                    drinks.forEach(d => {
                        let val = d[m.key];
                        let display = val !== null ? m.prefix + val + m.suffix : '-';
                        let cls = (best !== null && val === best) ? ' class="text-success fw-bold"' : '';
                        row += `<td${cls}>${display}</td>`;
                    });
                    row += '</tr>';
                    body.innerHTML += row;
                });

                results.classList.remove('d-none');
            });
    });
}

function correlations() {
    if(typeof corr_data === 'undefined') {
        return;
    }

    let dates = corr_data.dates.map((d: string) => Date.parse(d));

    // Year dropdown navigation
    on('change','select[name="corr_year"]',(element : HTMLInputElement) => {
        location.href = '?year=' + element.value;
    });

    // Date range navigation
    on('change','input[name="corr_from"],input[name="corr_to"]',(element : HTMLInputElement) => {
        let from = element.name === 'corr_from' ? element.value : document.querySelector<HTMLInputElement>('input[name="corr_from"]')?.value;
        let to = element.name === 'corr_to' ? element.value : document.querySelector<HTMLInputElement>('input[name="corr_to"]')?.value;
        location.href = '?from=' + from + '&to=' + to;
    });

    function dualAxisChart(container: string, title: string, series1Name: string, series1Data: any[], series1Color: string, series2Name: string, series2Data: any[], series2Color: string) {
        Highcharts.chart(container, Highcharts.merge(getChartTheme(), {
            chart: { height: 320, zooming: { type: 'x' } },
            title: { text: title, style: { fontSize: '14px' } },
            xAxis: { type: 'datetime' },
            yAxis: [
                { title: { text: series1Name, style: { color: series1Color } }, gridLineWidth: 0.1 },
                { title: { text: series2Name, style: { color: series2Color } }, gridLineWidth: 0.1, opposite: true }
            ],
            series: [
                { type: 'column', name: series1Name, data: series1Data.map((v: any, i: number) => [dates[i], v]), color: series1Color, yAxis: 0 },
                { type: 'spline', name: series2Name, data: series2Data.map((v: any, i: number) => [dates[i], v]), color: series2Color, yAxis: 1, connectNulls: true }
            ],
            plotOptions: { column: { borderWidth: 0 }, spline: { lineWidth: 2, marker: { enabled: false } } },
            credits: { enabled: false }
        }));
    }

    dualAxisChart('chart_alc_weight', 'Alcohol vs Weight', 'Drinks', corr_data.drinks, '#3BABD3', 'Weight (lbs)', corr_data.weight, '#BB72F4');
    dualAxisChart('chart_alc_km', 'Alcohol vs Runs', 'Drinks', corr_data.drinks, '#3BABD3', 'KM', corr_data.km, '#0090FF');
    dualAxisChart('chart_alc_spending', 'Alcohol vs Spending', 'Drinks', corr_data.drinks, '#3BABD3', 'Spending ($)', corr_data.spending, '#FF5733');
}
